import { Injectable } from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class SeoService {

  constructor(private meta: Meta, private title: Title) {
    this.generateTags({});
  }

  generateTags(config: any) {
    // default values
    config = {
      title: 'Embark on an exciting career journey with Destination Nuclear',
      description: 'Destination Nuclear is the place for students and young people to find apprenticeships, internships, graduate opportunities and early career jobs across multiple sectors',
      image: 'https://destinationnuclearcareersportal.co.uk/static/dn_hero_1.jpg',
      slug: '',
      url: 'https://destinationnuclearcareersportal.co.uk',
      ...config
    };

    this.title.setTitle(config.title);

    this.meta.updateTag({ name: 'twitter:card', content: 'summary' });
    this.meta.updateTag({ name: 'twitter:title', content: config.title });
    this.meta.updateTag({ name: 'twitter:description', content: config.description });
    this.meta.updateTag({ name: 'twitter:image', content: config.image });

    this.meta.updateTag({ property: 'og:type', content: 'article' });
    this.meta.updateTag({ property: 'og:site_name', content: 'Destination Nuclear' });
    this.meta.updateTag({ property: 'og:title', content: config.title });
    this.meta.updateTag({ property: 'og:description', content: config.description });
    this.meta.updateTag({ property: 'og:image', content: config.image });
    this.meta.updateTag({ property: 'og:url', content: config.url });
  }

}
